import PIXI from 'pixi.js/src';
import renderHelper from './../helpers/render';
import aguid from 'aguid';
import GameStore from './../stores/GameStore';
import data from './../data/data';
import frameAnimationHelper from './../helpers/frame-animation';
import stephCurry from './steph-curry';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const ball = {
  ballWidth: 15,
  ballHeight: 15,
  ballAnimationImagePaths: [],
  paused: false,


  /**
   * Sets up, adds event listeners
   * @returns {undefined} undefined
   */
  init() {
    this.gameStoreListener = this.onGameStoreChange.bind(this);
    GameStore.addChangeListener(this.gameStoreListener);

    this.ballAnimationImagePaths = data.ballPaths;
  },


  /**
   * Creates a ball
   * @param {Number} level - The game level
   * @param {Number} xPosition - The ball x position
   * @param {Number} velocity - The ball velocity
   * @param {Boolean} onFire - If the ball should be on fire
   * @returns {undefined} undefined
   */
  create(level, xPosition, velocity, onFire) {
    const _this = this;
    const randomBallPath =
      this.ballAnimationImagePaths[
        Math.floor(Math.random() * this.ballAnimationImagePaths.length)];
    let speed = 2.5 - velocity;

    if (speed < 0.8) {
      speed = 0.8;
    }

    this.fireballAnimationImagePaths = data.fireballPaths;

    this.ballContainer = new PIXI.Container();
    this.ballSprite = new PIXI.Sprite(
      PIXI.loader.resources[randomBallPath].texture
    );
    this.ballSprite.width = this.ballWidth;
    this.ballSprite.height = this.ballHeight;
    this.ballContainer.addChild(this.ballSprite);

    this.ballContainer._gameId = aguid();
    this.ballContainer.x = xPosition;
    this.ballContainer.y = window.innerHeight - stephCurry.stephHeight - this.ballHeight;
    this.ballContainer.width = this.ballWidth;
    this.ballContainer.height = this.ballHeight;

    if (onFire) {
      frameAnimationHelper.create(
        this.ballContainer,
        this.fireballAnimationImagePaths,
        0.3,
        true,
        15,
        34.5);
    }

    GameStore.addBall(this.ballContainer);
    renderHelper.stage.addChild(this.ballContainer);

    this.tween = window.TweenLite.to(
      this.ballContainer,
      speed,
      {
        autoKill: true,
        y: -this.ballHeight,
        ease: window.Linear.easeNone,
        onComplete() {
          _this.destroy();
        },
      }
    );
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const state = GameStore.getState();

    if (state.ballToRemove &&
      state.ballToRemove._gameId === this.ballContainer._gameId) {
      this.destroy();
    }

    if (state.paused) {
      if (!this.paused) {
        this.paused = true;
        this.tween.pause();
      }
    } else {
      if (this.paused) {
        this.paused = false;
        this.tween.resume();
      }
    }
  },


  /**
   * Destroys the ball
   * @returns {undefined} undefined
   */
  destroy() {
    if (this.tween) {
      this.tween.kill();
      this.tween = null;
    }

    GameStore.removeBall(this.ballContainer);
    GameStore.removeChangeListener(this.gameStoreListener);
    renderHelper.stage.removeChild(this.ballContainer);
  },
};

export default ball;



/** WEBPACK FOOTER **
 ** ./assets/js/src/graphics/ball.js
 **/